import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8080',
});


axiosInstance.interceptors.request.use((config) => {
    // Obtener el token desde localStorage
    const userDetails = localStorage.getItem('userDetails');

    if (userDetails) {
        try {
            const parsedDetails = JSON.parse(userDetails);
            const token = parsedDetails.access_token;

            if (token) {
                // Agregar el token como Bearer token en el header Authorization
                config.headers.Authorization = `Bearer ${token}`;
            }
        } catch (error) {
            console.error('Error al parsear userDetails desde localStorage:', error);
        }
    }

    return config;
});

export default axiosInstance;
